import { defineMessages } from 'react-intl';

export default defineMessages({
  CLOSE_TOAST: {
    defaultMessage: "Fermer l'alerte",
  },
});
